//
// Copyright (c) 2011-2021 by Curalate, Inc.
//

import styled from 'styled-components';

import { getRgbaForThemeHex } from '@utils/getRgbaForThemeHex';

export const FacebookMentionWrapper = styled.span<{
  hasError?: boolean;
}>(
  ({ hasError, theme }) => `
    position: relative;
    background-color: ${getRgbaForThemeHex(
      hasError ? theme.colors.aliases.error : theme.colors.aliases.primary,
      0.1,
    )};
  `,
);
